import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Autocomplete from '@mui/material/Autocomplete';
import { Accordion, AccordionDetails, AccordionSummary, FormControl, Grid, TextField } from '@mui/material';
import { pickBy } from 'lodash';
import { SyntheticEvent, useMemo, useState } from 'react';
import { connect } from 'react-redux';
import { ProductCategoryDto, ProductGroupDto } from '../../../common/PricePrgClient';
import { RootState } from '../../../store';

const mapStateToProps = (state: RootState) => ({
    productGroups: state.product.productGroups,
    productCategories: state.product.productCategories
});

type OwnProps = {
    handleProductGroupChanged: (event: React.ChangeEvent<unknown>, value: ProductGroupDto[]) => void;
    handleProductCategoryChanged: (event: React.ChangeEvent<unknown>, value: ProductCategoryDto[]) => void;
    handleProductCategory2Changed: (event: React.ChangeEvent<unknown>, value: ProductCategoryDto[]) => void;
    costGroupProductGroups: number[];
    costGroupProductCategories: number[];
    costGroupProductCategories2: number[];
};

type Props = ReturnType<typeof mapStateToProps> & OwnProps;

const ConditionSelector = ({
    productGroups,
    productCategories,
    handleProductGroupChanged,
    handleProductCategoryChanged,
    handleProductCategory2Changed,
    costGroupProductCategories,
    costGroupProductCategories2,
    costGroupProductGroups
}: Props) => {
    const [isExpanded, setExpanded] = useState(false);
    const productCategories1 = useMemo(
        () => Object.values(pickBy(productCategories, value => value.level === 1)),
        [productCategories]
    );
    const productCategories2 = useMemo(
        () => Object.values(pickBy(productCategories, value => value.level === 2)),
        [productCategories]
    );
    const handleChange = (event: SyntheticEvent<Element, Event>, newExpanded: boolean) => {
        setExpanded(newExpanded);
    };
    const costgroupCategoriesVals = useMemo(() => {
        return Object.values(costGroupProductCategories);
    }, [costGroupProductCategories]);

    const costgroupCategories2Vals = useMemo(() => {
        return Object.values(costGroupProductCategories2);
    }, [costGroupProductCategories2]);
    return (
        <Accordion square expanded={isExpanded} onChange={handleChange}>
            <AccordionSummary aria-controls="conditions" id="condition-panel" expandIcon={<ExpandMoreIcon />}>
                Conditions
            </AccordionSummary>
            <AccordionDetails>
                <Grid container>
                    <Grid item xs={12}>
                        <FormControl sx={{ width: '100%', marginBottom: '15px' }}>
                            <Autocomplete
                                multiple
                                id="product-groups-outlined"
                                options={Object.values(productGroups)}
                                getOptionLabel={(option: ProductGroupDto) => option.name}
                                defaultValue={costGroupProductGroups.map(c => productGroups[c])}
                                onChange={handleProductGroupChanged}
                                filterSelectedOptions
                                renderInput={params => (
                                    <TextField
                                        {...params}
                                        variant="outlined"
                                        label="Product group"
                                        placeholder="Product group"
                                    />
                                )}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12}>
                        <FormControl sx={{ width: '100%', marginBottom: '15px' }}>
                            <Autocomplete
                                multiple
                                id="product-categories-outlined"
                                options={productCategories1}
                                getOptionLabel={(option: ProductCategoryDto) => option.name}
                                defaultValue={costgroupCategoriesVals.map(c => productCategories[c])}
                                onChange={handleProductCategoryChanged}
                                filterSelectedOptions
                                renderInput={params => (
                                    <TextField
                                        {...params}
                                        variant="outlined"
                                        label="Product category"
                                        placeholder="Product category"
                                    />
                                )}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12}>
                        <FormControl sx={{ width: '100%' }}>
                            <Autocomplete
                                multiple
                                id="product-categories2-outlined"
                                options={productCategories2}
                                getOptionLabel={(option: ProductCategoryDto) => option.name}
                                defaultValue={costgroupCategories2Vals.map(c => productCategories[c])}
                                onChange={handleProductCategory2Changed}
                                filterSelectedOptions
                                renderInput={params => (
                                    <TextField
                                        {...params}
                                        variant="outlined"
                                        label="Product category 2"
                                        placeholder="Product category 2"
                                    />
                                )}
                            />
                        </FormControl>
                    </Grid>
                </Grid>
            </AccordionDetails>
        </Accordion>
    );
};

export default connect(mapStateToProps)(ConditionSelector);
